/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type StatisticType = 'Communities' | 'Projects' | 'Individuals' | 'Organizations';

export const StatisticType = {
    Communities: 'Communities' as StatisticType,
    Projects: 'Projects' as StatisticType,
    Individuals: 'Individuals' as StatisticType,
    Organizations: 'Organizations' as StatisticType
};